import { ISnackbarProgress } from './types';
import { SnackbarVariant, ISnackbarControlModel } from '../../store/types';

export const getSnackbarProgress = (
    options: ISnackbarProgress
) => {
    const buttons: ISnackbarControlModel[] = [{
        onClick: () => undefined,
        progress: options.buttonProgress,
        text: options.buttonTitle ?
            options.buttonTitle :
            options.buttonProgress + '%'
    }];
    return {
        ...options,
        buttons,
        variant: SnackbarVariant.PROGRESS
    }
};
